"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BytesField = void 0;
const register_1 = require("../../register");
const BytesField = (size = null) => {
    const serializer = {
        serialize: (value, buf) => {
            const val = Buffer.from(value, "hex");
            if (size == null) {
                const buf2 = Buffer.alloc(4);
                buf2.writeUInt32BE(val.length);
                return Buffer.concat([buf, buf2, val]);
            }
            const _matchSize = (input, size) => {
                if (input.byteLength == size) {
                    return input;
                }
                else if (input.byteLength > size) {
                    return input.slice(0, size);
                }
                else {
                    return Buffer.concat([
                        input,
                        Buffer.from("00".repeat(size - input.byteLength), "hex")
                    ]);
                }
            };
            return Buffer.concat([buf, _matchSize(val, size)]);
        },
        deserialize: (buf) => {
            if (size == null) {
                if (buf.length < 4)
                    throw new Error();
                const size = buf.readUInt32BE();
                buf = buf.slice(4);
                if (buf.length < size)
                    throw new Error();
                return [
                    buf.slice(0, size).toString("hex"),
                    buf.slice(size),
                ];
            }
            if (buf.length < size)
                throw new Error();
            return [
                buf.slice(0, size).toString("hex"),
                buf.slice(size),
            ];
        },
    };
    return (0, register_1.buildField)(serializer)();
};
exports.BytesField = BytesField;
//# sourceMappingURL=bytes.js.map